import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import { getServiceConfig } from "@/common/serviceConfigurations";
import TrainingHub from "@/components/training/TrainingHub";
import { Permission } from "@/components/UserManagement/types";
import { userPermissionChecks } from "@/components/UserManagement/utils";
import { AuthStateContext } from "@/contexts/AuthContext";
import { useDevEnvironment } from "@/contexts/DevContext";

const TRAINING_SECTIONS = [
  {
    id: "how-to-search-bulletins",
    headingKey: "training_search_heading",
    videoTitleKey: "training_search_video_title",
    loomId: "85eb55493b7242b0939d788efb0d53e6",
    thumbnailUrl:
      "https://cdn.loom.com/sessions/thumbnails/85eb55493b7242b0939d788efb0d53e6-3445d264c5cf9811.jpg",
  },
  {
    id: "how-moderation-works",
    headingKey: "training_moderation_heading",
    videoTitleKey: "training_moderation_video_title",
    loomId: "6b182d6caaab4f11994081dee636235f",
    thumbnailUrl:
      "https://cdn.loom.com/sessions/thumbnails/6b182d6caaab4f11994081dee636235f-c152c8ce051f98ac.jpg",
  },
  {
    id: "update-user-permissions",
    headingKey: "training_permissions_heading",
    videoTitleKey: "training_permissions_video_title",
    loomId: "13280ced051f45d195d7c002571e739a",
    thumbnailUrl:
      "https://cdn.loom.com/sessions/thumbnails/13280ced051f45d195d7c002571e739a-2daddb63ed7aeb39.jpg",
  },
] as const;

const AlertTraining: React.FC = () => {
  const { t } = useTranslation("bulletin");
  const { currentUser } = useContext(AuthStateContext);
  const { isDevEnv } = useDevEnvironment();
  const currentUserPermissions =
    currentUser?.permissions?.map((permission) => permission.title) ?? [];
  const userPermissions = userPermissionChecks(currentUserPermissions);
  const organizationConfig = getServiceConfig(
    currentUser?.rubi_org_id ?? "NA",
    isDevEnv,
  );
  const organizationAppPermissions = organizationConfig?.apps ?? [];

  if (
    !userPermissions.canAccessAlertsApp ||
    !organizationAppPermissions.includes(Permission.ALERT)
  ) {
    return <Navigate to="/" replace />;
  }

  return (
    <TrainingHub
      title={t("training_title")}
      sections={TRAINING_SECTIONS.map((section) => ({
        id: section.id,
        heading: t(section.headingKey),
        video: {
          title: t(section.videoTitleKey),
          loomId: section.loomId,
          thumbnailUrl: section.thumbnailUrl,
        },
      }))}
      support={{
        prefix: t("training_more_coming_prefix"),
        suffix: t("training_more_coming_suffix"),
        emailSubject: t("training_request_email_subject"),
        emailBody: t("training_request_email_body"),
      }}
    />
  );
};

export default AlertTraining;
